import { UnidadeViewModel } from '@models/Unidade';
import React, { useMemo } from 'react';
import { DataGrid,  } from '@material-ui/data-grid';
import { Button, LinearProgress } from '@material-ui/core';
import { UsuarioFiltro } from '@models/Usuario';
import { AbrirNoInfor } from '@services/AuthService';

interface UnidadeUsuarioListProps {
    unidadeCurrent: UnidadeViewModel
}
const UnidadeUsuarioList: React.FC<UnidadeUsuarioListProps> = ({ unidadeCurrent }) => {

    const BotaoAbrirHandler = async (usuario: UsuarioFiltro) => {
        const {unidadeId,senha,usuarioLogin} = usuario;
      try {
       await  AbrirNoInfor(`${unidadeId}-${usuarioLogin}-${senha}`);
      } catch (error) {
          console.log(error);
          alert(error)
          
      }
    }
    let columns = useMemo(() => {
        return [
            { field: 'usuarioId', headerName: 'ID' },
            { field: 'usuarioNome', headerName: 'Nome', flex: 1 },
            { field: 'usuarioLogin', headerName: 'Login', flex: 1 },
            { field: 'senha', headerName: 'Senha' },
            {
                field: 'nivel',
                headerName: 'Nivel',
                type: 'number',

            },
            {
                field: 'acao',
                headerName: 'Ações',
                renderCell: (params: any) => {
                    let usuario = (params.row as any) as UsuarioFiltro;

                    return <Button onClick={
                      async  () =>  { await BotaoAbrirHandler(usuario); }
                    }>Abrir</Button>;
                }

            }
        ]
    }, [unidadeCurrent])


    let rows = useMemo(() => {
        if (!unidadeCurrent.usuarios) return []
        return unidadeCurrent.usuarios;
    }, [unidadeCurrent.usuarios])
    return <div style={{ height: '100%', minHeight: '400px', width: '100%', marginBottom: "100px", paddingBottom: '100px' }}>
        {unidadeCurrent.usuarios ? <DataGrid getRowId={x => x.usuarioId} rows={rows} columns={columns} pageSize={30} /> : <LinearProgress />}

    </div>
}

export default UnidadeUsuarioList;
